<template>
  <div>
    <div class="text-xs-right">
      <div>
        <v-btn outline @click="showsearch = true"><v-icon>search</v-icon>search</v-btn>
      </div>
      <v-btn :loading="exportloading" @click="exportxlsx" color="grey" outline>
        <em class="fas fa-file-export" />
        &nbsp; Export&nbsp;
      </v-btn>
    </div>
    <v-pagination
      :total-visible="15"
      v-model="pageNumber"
      @input="changePage"
      :length="pagelength"
    ></v-pagination>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      hide-actions
      :pagination.sync="pagination"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            {{ props.item.code }}
          </td>
          <td>
            {{ props.item.amount }}
          </td>
          <td>
            {{ props.item.is_used ? 'ใช้แล้ว' : 'ยังไม่ได้ใช้งาน' }}
          </td>
          <td>
            {{ props.item.username }}
          </td>
          <td>
            {{ props.item.phone }}
          </td>
          <td>
            {{ formatdate(props.item.timestamp) }}
          </td>
          <td>
            {{ formatdate(props.item.used_timestamp) }}
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="showsearch" width="500px" persistent>
      <v-card>
        <div style="float: right">
          <v-btn @click="showsearch = false" icon><v-icon>close</v-icon></v-btn>
        </div>
        <div class="pa-2 pt-4 pb-3">
          <div style="font-weight: 600; font-size: 20px"><v-icon>search</v-icon> ค้นหา</div>
          <div>
            <v-layout class="pa-0 ma-0" wrap row>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>{{ $t('เลขที่บาร์โค๊ด') }}</label>
                <input v-model="filter.code" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>{{ $t('มูลค่า') }}</label>
                <input v-model="filter.amount" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm12 class="form-control pa-1">
                <label>{{ $t('ชื่อ') }}</label>
                <input v-model="filter.name" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm12 class="pa-1">
                <label>{{ $t('สถานะ') }}</label>
                <v-select
                  :items="statusOption"
                  v-model="filter.is_used"
                  :label="$t('สถานะ')"
                  class="mr-2 px-0"
                  dense
                  solo
                  style="font-size: 14px"
                ></v-select>
                <!-- <input v-model="filter.is_used" class="form-control" type="text" /> -->
              </v-flex>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>วันที่ได้รับ</label>
                <DatePickerWithoutButton v-model="filter.receivedDate">
                  <input
                    readonly
                    :value="formatdate(filter.receivedDate)"
                    class="form-control"
                    type="text"
                  />
                </DatePickerWithoutButton>
              </v-flex>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>วันที่ใช้คูปอง</label>
                <DatePickerWithoutButton v-model="filter.usedDate">
                  <input
                    readonly
                    :value="formatdate(filter.usedDate)"
                    class="form-control"
                    type="text"
                  />
                </DatePickerWithoutButton>
              </v-flex>
            </v-layout>
          </div>
          <div class="text-xs-center">
            <v-btn @click="clearsearch" outline color="grey">Clear</v-btn>
            <v-btn @click="onsearch" color="primary">Search</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import importxlsx from '@/components/elements/importxlsx.vue'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import { mapGetters } from 'vuex'
import ProductEdit from './ProductEdit.vue'
import VueQr from 'vue-qr'
import XLSX from 'xlsx'
import moment from 'moment'

export default {
  components: {
    ProductEdit,
    VueQr,
    importxlsx,
    exportxlsx,
    DatePickerWithoutButton
  },
  data() {
    return {
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      importloading: false,
      qrdata: '',
      showEdit: false,
      editdata: '',
      edittype: '',

      pagination: { rowsPerPage: -1, sortBy: 'branch_id' },
      columnName: '',
      items: [],
      filter: {
        code: '',
        amount: '',
        is_used: '',
        name: '',
        receivedDate: '',
        usedDate: ''
      },
      exportloading: false,
      showsearch: false,
      loading: false,
      headers: [
        { text: 'เลขที่บาร์โค๊ด', value: 'barcode_no' },
        { text: 'มูลค่า', value: 'charges' },
        { text: 'สถานะ', value: 'status' },
        { text: 'ชื่อลูกค้า', value: 'username' },
        { text: 'เบอร์โทรศัพท์', value: 'phone' },
        { text: 'วันที่ได้รับ', value: 'timestamp' },
        { text: 'วันที่ใช้คูปอง', value: 'used_timestamp' }
      ],
      selectedDate: null,
      statusOption: [
        { text: 'ใช้แล้ว', value: true },
        { text: 'ยังไม่ได้ใช้งาน', value: false }
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 10)
      } else {
        return 1
      }
    },

    selectedCampaign() {
      return this.$store.state.selectToaCampaign
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    clearsearch() {
      this.filter = {
        code: '',
        amount: '',
        is_used: '',
        name: '',
        receivedDate: '',
        usedDate: ''
      }
      this.getData()
      this.showsearch = false
    },
    onsearch() {
      this.getData()
      this.showsearch = false
    },
    async exportxlsx() {
      var data = {
        pageid: this.selectedBot.pageid,
        limit: this.total,
        offset: this.offset,
        code: this.filter.code, // optional
        amount: this.filter.amount, // optional
        is_used: this.filter.is_used, // optional
        name: this.filter.name,
        receivedDate: this.filter.receivedDate,
        usedDate: this.filter.usedDate,
        campaignid: this.selectedCampaign ? this.selectedCampaign.id : null
      }
      this.exportloading = true
      api.getUsedCouponToaecoupon(data, (err, response) => {
        var exporteddata = response.data

        var json = exporteddata.map((el) => {
          var status
          if (el.is_used) {
            status = 'ใช้แล้ว'
          } else {
            status = 'ยังไม่ได้ใช้งาน'
          }
          return {
            เลขที่บาร์โค๊ด: el.code,
            มูลค่า: el.amount,
            สถานะ: status,
            ลูกค้า: el.username,
            เบอร์โทรศัพท์: el.phone,
            วันที่ได้รับ: el.timestamp,
            วันที่ใช้คูปอง: el.used_timestamp
          }
        })

        const dataWS = XLSX.utils.json_to_sheet(json)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, dataWS)
        XLSX.writeFile(wb, 'exportecoupon' + '.xlsx')
        this.exportloading = false
      })
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getData()
      }
    },
    getData() {
      var data = {
        pageid: this.selectedBot.pageid,
        limit: this.limit,
        offset: this.offset,
        start_date: '',
        end_date: '',
        campaignid: this.selectedCampaign ? this.selectedCampaign.id : null
        // code: this.filter.code, // optional
        // amount: this.filter.amount, // optional
        // is_used: this.filter.is_used, // optional
        // name: this.filter.name,
        // receivedDate: this.filter.receivedDate,
        // usedDate: this.filter.usedDate
      }
      for (const key in this.filter) {
        if (this.filter[key]) {
          Object.assign(data, { [key]: this.filter[key] })
        }
      }
      this.loading = true
      api.getUsedCouponToaecoupon(data, (err, response) => {
        this.loading = false
        this.items = response.data
        this.total = response.total
      })
    },
    formatdate(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY')
      } else return ''
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/Ecoupon.vue